import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "cover-spin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "outer" }, [
      _createElementVNode("div", { class: "middle" }, [
        _createElementVNode("div", { class: "inner" }, [
          _createElementVNode("h3", { class: "text-center" }, [
            _createElementVNode("b", null, "Hang on. We're getting you the lowest prices.")
          ])
        ])
      ])
    ], -1)
  ]))]))
}